// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"80b35734","583":"49505daa"}[chunkId] + ".chunk.css";
};